<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card Title-bar-blue">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header Title-bar-text"><i class="fas fa-search mr-1"></i> User Approval Search</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>
  <section>
      <div class="row">
          <div class="col-md-12">
              <div class="card">
                  <div class="devcare-card-body">
                    <div class="row">
                        <div class="col-md-12">
                            <button [ngClass] = "showTopFilters === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"  pButton type="button" icon="pi pi-filter" (click)="bindShowTopFilter()"
                             style="float: right;height: 30px;" label="Show Filter"></button>
                        </div>
                    </div>
                    <div class="row" *ngIf="showTopFilters">
                        <div class="col-md-10">
                            <div class="p-fluid p-formgrid p-grid">
                               
                            </div>
                        </div>
                        <div class="col-md-2 d-flex align-items-center">
                            <button pButton pRipple type="button" label="Save Filter" icon="pi pi-search"
                                class="p-button-sm p-button-raised m-2" style="height: 30px;" (click)="saveFilter()"></button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <button [ngClass] = "showSorting === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'" pButton type="button" icon="pi pi-fw pi-sort-alt" (click)="bindShowSorting()"
                            [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                            <button [ngClass] = "showFilters === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"  pButton type="button" icon="pi pi-filter" (click)="bindShowFilter()"
                            [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                        </div>
                        <div class="col-md-8">

                            <button pButton label="Export" class="p-button-raised  m-2" icon="pi pi-file-excel" type="button" *ngIf="sharedService.checkPermission('Admin_Export')" style="float: right;height: 30px;"
                             ></button>
                            
                             <button pButton label="Clear" class="p-button-raised m-2" icon="pi pi-filter-slash" (click)="clearFilter(dt2)" 
                            style="float: right;height: 30px;"></button>

                            <!-- <button class="p-button-raised m-2" label ="Apply" pButton type="button" icon="pi pi-filter" (click)="applyFilter()"
                            [loading]="isSearchLoading" style="float: right;height: 30px;"></button> -->
                            

                        </div>
                    </div>
                  </div>
              </div>
          </div>
          <!-- <div class="col-md-1"></div> -->
      </div>
  </section>
  <section>
    <div class="row">
        <!-- <div class="col-md-1"></div>-->
        <div class="col-md-12">
            <div class="card">
                <div class="devcare-table-card-header">
                    
                </div>
                <div class="card-body devcare-table-card-body" style="overflow: hidden;">
                    <p-table #dt2 [value]="userApprovalList" paginatorDropdownAppendTo="body" dataKey="id" [rows]="10" [sortOrder]="0" 
                    [lazy] = "true" (onLazyLoad)="loadUserApprovalList($event)"
                    [showCurrentPageReport]="true" [resizableColumns]="true" columnResizeMode="expand"  
                    [rowsPerPageOptions]="[10,25,50]" [loading]="loading" styleClass="p-datatable-gridlines" 
                        [paginator]="true" [totalRecords]="totalRecords"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        [globalFilterFields]="['firstName','lastName','companyName', 'createdOn']">
                        
                        
                        <ng-template pTemplate="header">
                            <tr>
                                <th pResizableColumn style="width: 8rem">First Name  <span pSortableColumn="firstName" *ngIf="showSorting"><p-sortIcon field="firstName"></p-sortIcon></span>
                                    <p-columnFilter [hidden]="!showFilters" type="text" field="firstName" display="menu" [showAddButton]="false" [showOperator]="false"  
                                    [matchModeOptions]="matchModeOptions"  [showClearButton]="false" [showApplyButton]="false">
                                    </p-columnFilter>
                                </th>
                                <th pResizableColumn style="width: 8rem">Last Name <span pSortableColumn="lastName" *ngIf="showSorting"><p-sortIcon field="lastName"></p-sortIcon></span>
                                    <p-columnFilter [hidden]="!showFilters" type="text" field="lastName" display="menu" [showAddButton]="false" [showOperator]="false"  
                                    [matchModeOptions]="matchModeOptions" [showClearButton]="false" [showApplyButton]="false">
                                    </p-columnFilter>
                                </th>
                                <th pResizableColumn style="width: 8rem">Company Name <span pSortableColumn="companyName" *ngIf="showSorting"><p-sortIcon field="companyName"></p-sortIcon></span>
                                    <p-columnFilter [hidden]="!showFilters" type="text" field="companyName" display="menu" [showAddButton]="false" [showOperator]="false"  
                                    [matchModeOptions]="matchModeOptions" [showClearButton]="false" [showApplyButton]="false">
                                    </p-columnFilter>
                                </th>
                                <th pResizableColumn style="width: 8rem">Is Active  <span pSortableColumn="isActive" *ngIf="showSorting"><p-sortIcon field="isActive"></p-sortIcon></span>
                                    <p-columnFilter [hidden]="!showFilters" type="boolean" display="menu" field="isActive" 
                                    [showClearButton]="false" [showApplyButton]="false">
                                    </p-columnFilter>
                                </th>
                                <th pResizableColumn style="width: 8rem">Is Approved  <span pSortableColumn="isApproved" *ngIf="showSorting"><p-sortIcon field="isApproved"></p-sortIcon></span>
                                    <p-columnFilter [hidden]="!showFilters" type="boolean" display="menu" field="isApproved" 
                                    [showClearButton]="false" [showApplyButton]="false">
                                    </p-columnFilter>
                                </th> 
                                <th pResizableColumn style="width: 8rem">Created On <span pSortableColumn="createdOn" *ngIf="showSorting"><p-sortIcon field="createdOn"></p-sortIcon></span>
                                    <p-columnFilter [hidden]="!showFilters" type="date" field="createdOn" display="menu" [showAddButton]="showAddRuleButton" [showOperator]="false"  
                                    [matchModeOptions]="matchModeOptionsForDate" [showClearButton]="false" [showApplyButton]="false">
                                    </p-columnFilter>
                                </th>
                                <th pResizableColumn style="width: 7rem">Approve</th>
                                <th pResizableColumn style="width: 7rem">Action</th>
                            </tr>
                            <tr [hidden]="!showFilters">
                                <th>{{filters?.firstName[0]?.value}}</th>
                                <th>{{filters?.lastName[0]?.value}}</th>
                                <th>{{filters?.companyName[0]?.value}}</th>
                                <th>{{filters?.isActive[0]?.value}}</th>
                                <th>{{filters?.isApproved[0]?.value}}</th>
                                <th colspan="2">{{filters?.createdOn[0]?.value | date:'MM/dd/yyyy'}} <span *ngIf="filters?.createdOn.length > 1">-</span> {{filters?.createdOn[1]?.value | date:'MM/dd/yyyy'}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-userApprovalList>
                            <tr>
                                <td><span class="table-col-countryName">{{userApprovalList.firstName}}</span></td>
                                <td><span>{{userApprovalList.lastName}}</span></td>
                                <td><span>{{userApprovalList.companyName}}</span></td>
                                <td><span>{{userApprovalList.isActive}}</span></td>
                                <td><span>{{userApprovalList.isApproved}}</span></td>
                                <td><span>{{userApprovalList.createdOn | date:'MM/dd/yyyy'}}</span></td>
                                <td *ngIf="userApprovalList.isApproved === false">
                                    <button pButton pRipple type="button" icon="pi pi-check" (click)="approveUser(userApprovalList)" class="p-button-rounded p-button-success p-button-outlined"></button>
                                </td>
                                <td *ngIf="userApprovalList.isApproved === true">
                                    <button pButton pRipple type="button" icon="pi pi-times"  class="p-button-rounded p-button-danger p-button-outlined"></button>
                                </td>
                                <td>
                                    <span>
                                        <a [routerLink]="" class="table-icon table-icon-view" style="color: #9593df;"><i class="fas fa-eye"></i></a>&nbsp;&nbsp;
                                        <a [routerLink]="" class="table-icon" style="color: #ca86a8;"><i class="fas fa-file"></i></a>&nbsp;&nbsp;
                                        <p-menu class="[]" #menu popup="popup" [model]="items" appendTo="body"></p-menu>
                                        <a [routerLink]="" class="table-icon table-icon-menu"><i class="pi pi-ellipsis-v" (click)="menu.toggle($event)"></i></a>&nbsp;&nbsp;
                                    </span>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="5">No Users For Approval found.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
            <br>
            <br>
            <br>
            <br>
        </div>
        <!-- <div class="col-md-1"></div> -->
    </div>

</section>